/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [

  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
      },
    ],
  },
  {
    path: '/account/profile',
    name: 'account.settings',
    component: './user/profile',
    hideInMenu: true,
  },
  {
    path: '/',
    key: 'workbench',
    code: 'workbench',
    name: 'workbench',
    icon: 'DashboardOutlined',
    routes: [
      {
        path: '/workbench',
        redirect: '/welcome',
      },
      {
        path: '/welcome',
        code: 'welcome',
        name: 'today-overview',
        component: './Welcome',
      },
    ],
  },
  { path: '/analytics', code: 'analytics', name: 'analytics', icon: 'barChart', component: './tracking' },
  {
    path: '/',
    key: 'member_ops',
    code: 'member_ops',
    name: 'member_ops',
    icon: 'UserOutlined',
    routes: [
      {
        path: '/member-ops',
        redirect: '/member',
      },
      {
        path: '/member',
        code: 'member',
        name: 'member-list',
        component: './member',
      },
      {
        path: '/member_injury',
        code: 'member_injury',
        name: 'member-injury',
        component: './member_injury',
      },
      {
        path: '/member_wod',
        code: 'member-wods',
        name: 'member-wods',
        component: './member_wod',
      },
      {
        path: '/member_pr',
        code: 'member-prs',
        name: 'member-prs',
        component: './member_pr',
      },
      {
        path: '/member_feature',
        code: 'member-feature',
        name: 'member-feature',
        component: './member_feature',
      },
      {
        path: '/movements/member-videos',
        code: 'member-videos',
        name: 'member-movement-library',
        component: './member_movement_video',
      },
    ],
  },
  {
    path: '/',
    key: 'card_collection',
    code: 'card_collection',
    name: 'card_collection',
    icon: 'CreditCardOutlined',
    routes: [
      {
        path: '/card-collection',
        redirect: '/card_templates',
      },
      {
        path: '/card_templates',
        code: 'card-templates',
        name: 'card-templates',
        component: './card_template',
      },
      {
        path: '/member_card_instances',
        code: 'member-card-instances',
        name: 'card-instance-center',
        component: './member_card_instance',
      },
      {
        path: '/pause_operations',
        code: 'pause-operations',
        name: 'pause-operation-center',
        component: './pause_operation_center',
      },
      {
        path: '/transaction_orders',
        code: 'transaction-orders',
        name: 'transaction-order-center',
        component: './transaction_order',
      },
      {
        path: '/payment_reconciliation',
        code: 'payment-reconciliation',
        name: 'payment-reconciliation',
        component: './payment_reconciliation',
      },
    ],
  },
  {
    path: '/',
    key: 'course_ops',
    code: 'course_ops',
    name: 'course_ops',
    icon: 'CalendarOutlined',
    routes: [
      {
        path: '/course-ops',
        redirect: '/course_schedule',
      },
      {
        path: '/course_schedule',
        code: 'course_schedule',
        name: 'course-schedule',
        component: './course_schedule/schedule',
      },
      { path: '/course_schedule/:id/scores', code: 'course_schedule', name: 'course-scores', component: './course_schedule/CourseScores', hideInMenu: true },
	  {
		path: '/training_records',
		code: 'training_records',
		name: 'training-records',
		component: './training-record',
	  },
	  {
		path: '/training_records/create',
		code: 'training_records',
		name: 'training-record-create',
		component: './training-record/create',
		hideInMenu: true,
	  },
	  {
		path: '/training_records/:id',
		code: 'training_records',
		name: 'training-record-detail',
		component: './training-record/detail',
		hideInMenu: true,
	  },
    ],
  },
  {
    path: '/',
    key: 'training_content',
    code: 'training_content',
    name: 'training_content',
    icon: 'ReadOutlined',
    routes: [
      {
        path: '/training-content',
        redirect: '/wod',
      },
      {
        path: '/wod/create',
        code: 'wod',
        name: 'wod-template-create',
        component: './wod/edit',
        hideInMenu: true,
      },
      {
        path: '/wod/v2/create',
        code: 'wod',
        name: 'wod-v2-create',
        component: './wod-v2/create',
        hideInMenu: true,
      },
      {
        path: '/wod/v2/:id/edit',
        code: 'wod',
        name: 'wod-v2-edit',
        component: './wod-v2/edit',
        hideInMenu: true,
      },
      {
        path: '/wod/:id/edit',
        code: 'wod',
        name: 'wod-template-edit',
        component: './wod/edit',
        hideInMenu: true,
      },
      {
        path: '/wod',
        code: 'wod',
        name: 'wod-template',
        component: './wod',
      },
      {
        path: '/movements/index',
        code: 'index',
        name: 'movement-library',
        component: './movements/index',
      },
      {
        path: '/movements/accessories',
        code: 'accessories',
        name: 'accessories',
        component: './movements/accessories',
      },
      {
        path: '/movements/fitness-mappings',
        code: 'fitness-mappings',
        name: 'fitness-mappings',
        component: './movements/fitness_mapping',
      },
      {
        path: '/fitness-virtual-avatar-configs',
        code: 'fitness_virtual_avatar_configs',
        name: 'fitness-virtual-avatar-configs',
        component: './fitness_virtual_avatar_config',
      },
      {
        path: '/medias',
        code: 'medias',
        name: 'media-assets',
        component: './medias',
      },
    ],
  },
  {
    path: '/',
    key: 'mini_ai',
    code: 'mini_ai',
    name: 'mini_ai',
    icon: 'PlayCircleOutlined',
    routes: [
      {
        path: '/mini-ai',
        redirect: '/ai_video',
      },
      {
        path: '/ai_video/:id',
        code: 'ai_video',
        name: 'ai-video-review-detail',
        component: './video_ai/detail',
        hideInMenu: true,
      },
      {
        path: '/ai_video',
        code: 'ai_video',
        name: 'ai-video-review',
        component: './video_ai',
      },
      {
        path: '/wx_share_config',
        code: 'wx_share_config',
        name: 'wx-share-config',
        component: './wx_share_config',
      },
      {
        path: '/wx_mini_qrcode',
        code: 'wx_mini_qrcode',
        name: 'wx-mini-qrcode',
        component: './wx_mini_qrcode',
      },
    ],
  },
  {
    path: '/system',
    code: 'system',
    name: 'system',
    icon: 'setting',
    routes: [
      {
        path: '/system',
        redirect: '/system/menu',
      },
      {
        path: '/system/menu',
        code: 'menu',
        name: 'menu',
        component: './system/Menu',
      },
      {
        path: '/system/role',
        code: 'role',
        name: 'role',
        component: './system/Role',
      },
      {
        path: '/system/user',
        code: 'user',
        name: 'admin-account',
        component: './system/User',
      },
      {
        path: '/system/coach',
        code: 'coach',
        name: 'coach',
        component: './system/Coach',
      },
    ],
  },
  {
    path: '/',
    redirect: '/welcome',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
